<template>
  <div>
    <div class="post bg-yellow big-text">
      <div class="image">
        <video autoplay playsinline loop src="@/assets/2026/mercs3.mp4" style="height: 100%; width: 100%; object-fit: cover;" />
      </div>
      <div class="post-content-wrapper">
        <div class="post-header">Mercenaries</div>
        <pre class="post-content">
          Following growing dissatisfaction within Nordland’s armed forces over the nation’s decline, corruption, and lack of effective leadership, a number of officers initiated covert coup. Their objective was to establish an autonomous, disciplined force capable of acting independently from the government’s failing institutions. Equipment and supplies were stolen, armories were raided, and personnel from disbanded units were recruited into a unified structure. The objective is to create a functioning combat organization capable of independent operations.

          Under the command of <b>Colonel Jari Koskinen</b>, the group expanded from a small covert element into a self-sufficient military force. Initial actions included the seizure of weapons, vehicles, and army materiel from lightly defended depots. These resources allowed the formation of organized combat units with established command and logistics.

          The Mercenaries identify as a professional formation with a clear command structure and defined objectives. They view Nordland’s civilian leadership as ineffective and consider decisive military action the way to power.

          Primary objective: conduct an assault on the <b>Riksbank Gold Reserve</b> during the regional election period. The intent is to seize the gold, secure it for transport, and extract it from the area of operations (AO) via pre-established routes.

          Command maintains strict discipline and prioritizes efficiency and coordination. Loyalty to leadership and mission objectives is mandatory. The Mercenaries operate under the principle that control and stability can only be achieved through strength and organization.

          <i>Might is Right.</i>
        </pre>
      </div>
    </div>

    <div id="commander" class="post">
      <div class="image">
        <img src="@/assets/commander.jpg" alt="Commander" />
      </div>
      <pre class="post-content-wrapper">
        <div class="post-header">Commander</div>
        <div class="post-content">
          To be announced
        </div>
      </pre>
    </div>

    <div class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Quick links</div>
        <div class="post-content">
          <ul class="quicklinks">
            <li><a href="#infantry">Infantry</a></li>
            <li><a href="#mechanized">Mechanized Unit</a></li>
            <li><a href="#breach">Breach and Demolition Unit</a></li>
            <li><a href="#phantom">Phantom Unit</a></li>
            <li><a href="#recon">Reconnaissance Unit</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div id="infantry" class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Infantry</div>

        <pre class="post-content">
          The <b>Infantry</b> forms the main combat force of the Mercenaries. Trained for combat, they carry out patrols, secure objectives, and support other units in attacks and defensive operations across urban and rural areas. Equipped with standard & heavy weapons, they use firepower and coordinated tactics to achieve the unit's objectives.
        </pre>
        <hr>
        <div class="post-content">
          <table class="info-table">
            <tr>
              <td class="label-col"><b>Unit description</b></td>
              <td class="value-col">Infantry is a military specialization which engages in ground combat on foot.</td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit size</b></td>
              <td class="value-col">Maximum 500 soldiers</td>
            </tr>
            <tr>
              <td class="label-col"><b>Vehicle types</b></td>
              <td class="value-col">None</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband color</b></td>
              <td class="value-col">Yellow</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband marking</b></td>
              <td class="value-col">Player Number</td>
            </tr>
            <tr>
              <td class="label-col"><b>Uniform types</b></td>
              <td class="value-col">All uniform types allowed.</td>
            </tr>
            <tr>
              <td class="label-col"><b>Equipment style</b></td>
              <td class="value-col">Full army camoset and combat gear</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armament</b></td>
              <td class="value-col">Small arms, assault rifles, snipers & machine guns</td>
            </tr>
            <tr>
              <td class="label-col"><b>Expected playstyle</b></td>
              <td class="value-col">Action and military organization</td>
            </tr>
            <tr>
              <td class="label-col"><b>Physical requirement level</b></td>
              <td class="value-col">Normal</td>
            </tr>
            <tr>
              <td class="label-col"><b>LARP elements</b></td>
              <td class="value-col">None required</td>
            </tr>
            <tr>
              <td class="label-col"><b>Base & Logistics</b></td>
              <td class="value-col">Players are able to book a free spot in Berget-provided tents, drinking water, 230V
                power for battery charging, toilets, cold water showers, and small kiosk with food for sale
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of heavy anti-tank weapons</b></td>
              <td class="value-col">The yellow team gets 45% of the total supply. This unit can book and use anti-tank
                weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of light tank weapons</b></td>
              <td class="value-col">The yellow team gets 45% of the total supply. This unit can book and use light
                anti-tank weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Mandatory equipment to be brought by the player</b></td>
              <td class="value-col">All players must have a black balaclava. Will be available for purchase in the shop on site for a low price.
                It will not be used at all times but will be mandatory during certain missions.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Team equipment provided by Berget</b></td>
              <td class="value-col">-</td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit special requirements</b></td>
              <td class="value-col">No vehicles allowed. Players may not wear Ghillie or half-leaf suits</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="mechanized" class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Mechanized Unit</div>

        <pre class="post-content">
          The <b>Mechanized Unit</b> is the Mercenaries mobile combat force. Using armored vehicles, light transports, and all-terrain platforms, they move infantry, provide fire support, and respond quickly to threats. The unit secures key positions, supports attacks, and helps maintain control over contested areas.
        </pre>
        <hr>
        <div class="post-content">
          <table class="info-table">
            <tr>
              <td class="label-col"><b>Unit description</b></td>
              <td class="value-col">Mechanized are infantry units equipped with armored personnel carriers (APCs) or
                infantry fighting vehicles (IFVs) for transport and combat.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit size</b></td>
              <td class="value-col">Maximum 200 soldiers</td>
            </tr>
            <tr>
              <td class="label-col"><b>Vehicle types</b></td>
              <td class="value-col">Class 1 - 5</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband color</b></td>
              <td class="value-col">Yellow</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband marking</b></td>
              <td class="value-col">Player Number</td>
            </tr>
            <tr>
              <td class="label-col"><b>Uniform types</b></td>
              <td class="value-col">All uniform types allowed.</td>
            </tr>
            <tr>
              <td class="label-col"><b>Equipment style</b></td>
              <td class="value-col">Full army camoset and combat gear</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armament</b></td>
              <td class="value-col">Small arms, assault rifles, snipers & machine guns</td>
            </tr>
            <tr>
              <td class="label-col"><b>Expected playstyle</b></td>
              <td class="value-col">Action</td>
            </tr>
            <tr>
              <td class="label-col"><b>Physical requirement level</b></td>
              <td class="value-col">Normal</td>
            </tr>
            <tr>
              <td class="label-col"><b>LARP elements</b></td>
              <td class="value-col">None required</td>
            </tr>
            <tr>
              <td class="label-col"><b>Base & Logistics</b></td>
              <td class="value-col">Players are able to book a free spot in Berget-provided tents, drinking water, 230V
                power for battery charging, toilets, cold water showers, and small kiosk with food for sale
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of heavy anti-tank weapons</b></td>
              <td class="value-col">The yellow team gets 45% of the total supply. This unit can book and use anti-tank
                weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of light tank weapons</b></td>
              <td class="value-col">The yellow team gets 45% of the total supply. This unit can book and use light
                anti-tank weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Mandatory equipment to be brought by the player</b></td>
              <td class="value-col">In-game vehicle or a seat at a friend's vehicle. Players who bring a vehicle must
                book a hit-receiver.<br>
                All players must have a black balaclava. Will be available for purchase in the shop on site for a low
                price. It will not be used at all times but will be mandatory during certain missions.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Team equipment provided by Berget</b></td>
              <td class="value-col">–</td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit special requirements</b></td>
              <td class="value-col">Players may not wear Ghillie or half-leaf suits</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="breach" class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Breach and Demolition Unit</div>

        <pre class="post-content">
          The <b>Breach and Demolition Unit</b> is an assault engineer team trained to force entry, remove obstacles, and breach secured positions. They use explosive charges for locks and doors, sledgehammers and aluminium ladders to overcome fences and walls. They are qualified to enter vaults and hardened compounds.
        </pre>
        <hr>
        <div class="post-content">
          <table class="info-table">
            <tr>
              <td class="label-col"><b>Unit description</b></td>
              <td class="value-col">An assault engineer team trained to force entry, clear obstacles, and breach
                fortified positions using explosives, sledgehammers, and aluminum ladders. They support infantry and
                mechanized units.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit size</b></td>
              <td class="value-col">30 players</td>
            </tr>
            <tr>
              <td class="label-col"><b>Vehicle types</b></td>
              <td class="value-col">None</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband color</b></td>
              <td class="value-col">Yellow</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband marking</b></td>
              <td class="value-col">Player number</td>
            </tr>
            <tr>
              <td class="label-col"><b>Uniform types</b></td>
              <td class="value-col">All uniform types allowed.</td>
            </tr>
            <tr>
              <td class="label-col"><b>Equipment style</b></td>
              <td class="value-col">Full army camoset and combat gear</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armament</b></td>
              <td class="value-col">Small arms, assault rifles, snipers & machine guns</td>
            </tr>
            <tr>
              <td class="label-col"><b>Expected playstyle</b></td>
              <td class="value-col">Action</td>
            </tr>
            <tr>
              <td class="label-col"><b>Physical requirement level</b></td>
              <td class="value-col">Normal</td>
            </tr>
            <tr>
              <td class="label-col"><b>LARP elements</b></td>
              <td class="value-col">None required</td>
            </tr>
            <tr>
              <td class="label-col"><b>Base & Logistics</b></td>
              <td class="value-col">Players are able to book a free spot in Berget-provided tents, drinking water, 230V
                power for battery charging, toilets, cold water showers, and small kiosk with food for sale
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of heavy anti-tank weapons</b></td>
              <td class="value-col">The yellow team gets 45% of the total supply. This unit can book and use anti-tank
                weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of light tank weapons</b></td>
              <td class="value-col">The yellow team gets 45% of the total supply. This unit can book and use light
                anti-tank weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Mandatory equipment to be brought by the player</b></td>
              <td class="value-col">All players must have a black balaclava. Will be available for purchase in the shop
                on site for a low price. It will not be used at all times but will be mandatory during certain missions.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Team equipment provided by Berget</b></td>
              <td class="value-col">Aluminium ladders, explosive charges and sledgehammers. Bolt cutters, mine worms,
                mines, remote detonation charges. Smoke and pyrotechnics.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit special requirements</b></td>
              <td class="value-col">This unit will be allowed to use pyro and smoke provided by BE. All persons in this
                unit must undergo safety training before the start of the game.
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="phantom" class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Phantom Unit</div>

        <pre class="post-content">
          The <b>Phantom Unit</b> is the Mercenaries' specialized team for managing contacts with criminal gangs. While not all gangs are initially friendly, the unit works to <b>keep them under control, negotiate agreements, and maintain influence</b> over key networks. Skilled in discretion, negotiation and assassinations, the Phantom Unit operates in the shadows to expand the Mercenaries' reach, and secure critical resources without drawing unnecessary attention.
        </pre>
        <hr>
        <div class="post-content">
          <table class="info-table">
            <tr>
              <td class="label-col"><b>Unit description</b></td>
              <td class="value-col">A covert operations team tasked with handling contact and negotiation with criminal
                elements and assassinations. They secure influence through diplomacy, intimidation, and control of key
                assets.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit size</b></td>
              <td class="value-col">30 players</td>
            </tr>
            <tr>
              <td class="label-col"><b>Vehicle types</b></td>
              <td class="value-col">None</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband color</b></td>
              <td class="value-col">Yellow</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband marking</b></td>
              <td class="value-col">Player number on both armbands</td>
            </tr>
            <tr>
              <td class="label-col"><b>Uniform types</b></td>
              <td class="value-col">All uniform types allowed.</td>
            </tr>
            <tr>
              <td class="label-col"><b>Equipment style</b></td>
              <td class="value-col">Full army camoset and combat gear</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armament</b></td>
              <td class="value-col">Small arms, assault rifles.</td>
            </tr>
            <tr>
              <td class="label-col"><b>Expected playstyle</b></td>
              <td class="value-col">LARP & Action</td>
            </tr>
            <tr>
              <td class="label-col"><b>Physical requirement level</b></td>
              <td class="value-col">Normal</td>
            </tr>
            <tr>
              <td class="label-col"><b>LARP elements</b></td>
              <td class="value-col">Yes, players will often interact with all civilian sides. Players in this unit need
                to be well read in the story and the rules. The players should develop their own background story for
                their character.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Base & Logistics</b></td>
              <td class="value-col">Players are able to book a free spot in Berget-provided tents, drinking water, 230V
                power for battery charging, toilets, cold water showers, and small kiosk with food for sale
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of heavy anti-tank weapons</b></td>
              <td class="value-col">None</td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of light tank weapons</b></td>
              <td class="value-col">None</td>
            </tr>
            <tr>
              <td class="label-col"><b>Mandatory equipment to be brought by the player</b></td>
              <td class="value-col">Players must bring combat and civilian clothes as well as yellow and white & green
                armbands with their player numbers.<br>All players must have a black balaclava. Will be available for
                purchase in the shop on site for a low price. It will not be used at all times but will be mandatory
                during certain missions.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Team equipment provided by Berget</b></td>
              <td class="value-col">Berget dollars, drugs, gold testing equipment. Equipment for interrogation and
                documentation, handcuffs, flex-cuffs. Interrogation scripts, LARP drug testing equipment.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit special requirements</b></td>
              <td class="value-col">Can switch between civilian (white green) and Mercenary (yellow) roles (takes 30
                minutes and can only be done at the base). Must switch between uniform and civilian clothes.
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div id="recon" class="post">
      <div class="post-content-wrapper">
        <div class="post-header">Reconnaissance Unit</div>

        <pre class="post-content">
          The <b>Reconnaissance Unit</b> conducts surveillance, reconnaissance, and target identification in support of Mercenary operations. Small, mobile teams operate independently and behind enemy lines to locate enemy positions, mark targets, and monitor movements. Tasks include, base attacks and ambushes to hostile forces.
        </pre>
        <hr>
        <div class="post-content">
          <table class="info-table">
            <tr>
              <td class="label-col"><b>Unit description</b></td>
              <td class="value-col">Small, mobile teams operating behind enemy lines to locate targets, gather
                intelligence, and conduct ambushes or base raids to hostile forces.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit size</b></td>
              <td class="value-col">Maximum 100 soldiers</td>
            </tr>
            <tr>
              <td class="label-col"><b>Vehicle types</b></td>
              <td class="value-col">None</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband color</b></td>
              <td class="value-col">Yellow</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armband marking</b></td>
              <td class="value-col">Player number</td>
            </tr>
            <tr>
              <td class="label-col"><b>Uniform types</b></td>
              <td class="value-col">All uniform types allowed.</td>
            </tr>
            <tr>
              <td class="label-col"><b>Equipment style</b></td>
              <td class="value-col">Full army camoset and combat gear, Ghillie Suit or half-leaf suit</td>
            </tr>
            <tr>
              <td class="label-col"><b>Armament</b></td>
              <td class="value-col">Small arms, assault rifles, snipers & machine guns</td>
            </tr>
            <tr>
              <td class="label-col"><b>Expected playstyle</b></td>
              <td class="value-col">MILSIM</td>
            </tr>
            <tr>
              <td class="label-col"><b>Physical requirement level</b></td>
              <td class="value-col">High (Recommended minimum level Coopertest 2,3+ KM at 12 minutes or 40-44 vo2 max)
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>LARP elements</b></td>
              <td class="value-col">None required</td>
            </tr>
            <tr>
              <td class="label-col"><b>Base & Logistics</b></td>
              <td class="value-col">Players are able to book a free spot in Berget-provided tents, drinking water, 230V
                power for battery charging, toilets, cold water showers and small kiosk with food for sale. The unit
                must also operate self-sufficiently in parts of the game; small tents allowed for personal base. Fresh
                water will be provided at key objectives.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of heavy anti-tank weapons</b></td>
              <td class="value-col">The yellow team gets 45% of the total supply. This unit can book and use light
                anti-tank weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Supply of light tank weapons</b></td>
              <td class="value-col">The yellow team gets 45% of the total supply. This unit can book and use light
                anti-tank weapons.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Mandatory equipment to be brought by the player</b></td>
              <td class="value-col">Personal gear to be self-sufficient during operations, players need to bring a large
                backpack to carry food, water and equipment during missions.<br>All players must have a black balaclava.
                Will be available for purchase in the shop on site for a low price. It will not be used at all times but
                will be mandatory during certain missions.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Team equipment provided by Berget</b></td>
              <td class="value-col">The commander of this unit will receive a small extra supply of AT4s and mines to be
                used in missions.
              </td>
            </tr>
            <tr>
              <td class="label-col"><b>Unit special requirements</b></td>
              <td class="value-col">Previous Berget experience or military service background required. No vehicles
                allowed. Players must wear Ghillie or half-leaf suits. Players must be able to operate without full
                Berget-events logistics support when deployed.
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Resistance'
}
</script>

<style scoped>
b, .post-header, .label-col {
  color: #ffe6aa;
}

@media (min-width: 921px) {
  video {
    margin-top: 88px;
  }
}
</style>
